import { render } from "./campaign-management.vue?vue&type=template&id=ddb33450&ts=true"
import script from "./campaign-management.ts?vue&type=script&lang=ts&external"
export * from "./campaign-management.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__